import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CheckCircle } from 'lucide-react';

const STATES = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA',
  'PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'
];

export const ProfileInfluencerFields = ({
  influencerKey, setInfluencerKey, influencerKeyValid, validatingInvite, onValidateInvite,
  fullName, setFullName, cpf, setCpf, state, setState,
  city, citySearch, setCitySearch, setCity, showCitySuggestions, setShowCitySuggestions, filteredCities, handleCitySelect, cityRef,
  neighborhood, setNeighborhood, address, setAddress, pix, setPix
}) => (
  <div className="space-y-4 pt-2 border-t border-slate-200">
    <h2 className="text-lg font-bold text-slate-900">Dados do Influenciador</h2>

    <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4">
      <p className="text-sm text-indigo-700 font-medium mb-3">Chave de Convite</p>
      {!influencerKeyValid ? (
        <div className="flex items-center gap-2">
          <Input value={influencerKey} onChange={e => setInfluencerKey(e.target.value.toUpperCase())}
            placeholder="Ex: INF-A1B2C3D4" className="font-mono tracking-wider bg-white"
            data-testid="influencer-invite-key-input" />
          <Button type="button" onClick={onValidateInvite} disabled={validatingInvite}
            className="bg-indigo-600 hover:bg-indigo-700 text-white shrink-0" data-testid="validate-invite-btn">
            {validatingInvite ? 'Validando...' : 'Validar'}
          </Button>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle className="h-5 w-5" />
          <span className="font-medium">Chave validada com sucesso!</span>
        </div>
      )}
    </div>

    {influencerKeyValid && (
      <>
        <div><Label>Nome Completo</Label><Input value={fullName} onChange={e => setFullName(e.target.value)} required data-testid="inf-fullname" className="mt-1" /></div>
        <div><Label>CPF</Label><Input value={cpf} onChange={e => setCpf(e.target.value)} placeholder="000.000.000-00" required data-testid="inf-cpf" className="mt-1" /></div>
        <div>
          <Label>Estado</Label>
          <Select value={state} onValueChange={setState}>
            <SelectTrigger className="mt-1" data-testid="inf-state-select"><SelectValue placeholder="Selecione" /></SelectTrigger>
            <SelectContent>{STATES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="relative" ref={cityRef}>
            <Label>Cidade</Label>
            <Input value={citySearch || city} onChange={e => { setCitySearch(e.target.value); setCity(''); setShowCitySuggestions(true); }}
              onFocus={() => setShowCitySuggestions(true)} placeholder={state ? "Digite a cidade..." : "Selecione o estado primeiro"}
              disabled={!state} required data-testid="influencer-city-input" className="mt-1" />
            {showCitySuggestions && filteredCities.length > 0 && (
              <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
                {filteredCities.map(c => (
                  <button key={c} type="button" onClick={() => handleCitySelect(c)}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 transition-colors">{c}</button>
                ))}
              </div>
            )}
          </div>
          <div><Label>Bairro</Label><Input value={neighborhood} onChange={e => setNeighborhood(e.target.value)} data-testid="influencer-neighborhood-input" className="mt-1" /></div>
        </div>
        <div><Label>Endereco Completo</Label><Input value={address} onChange={e => setAddress(e.target.value)} required data-testid="inf-address" className="mt-1" /></div>
        <div><Label>Chave PIX (mesmo nome do cadastro)</Label><Input value={pix} onChange={e => setPix(e.target.value)} placeholder="CPF, email ou telefone" required data-testid="inf-pix" className="mt-1" /></div>
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-3">
          <p className="text-sm text-slate-700 font-medium">Parceria Mensal</p>
          <p className="text-xs text-slate-500 mt-1">Comissao de 10% sobre a mensalidade de cada lojista que aderir usando sua chave personalizada</p>
        </div>
      </>
    )}
  </div>
);
